import {
  Box,
  Container,
  Heading,
  HStack,
  Stack,
  VStack,
  Breadcrumb,
  BreadcrumbItem,
  useDisclosure,
  useToast,
  FormControl,
  FormHelperText,
  Text,
  Image,
  Alert,
  AlertIcon,
  Badge,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";

// import { ReactComponent as QrCode } from "assets/svg/qr-code.svg";

// import PinInput from "components/Input/PinInput";
import Button from "components/Button/Button";
import Input from "components/Input/Input";
import Select from "components/Select/Select";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import WithdrawPreview from "components/Modals/wallet/WithdrawPreview";

import Success from "components/Modals/Success";

import { useParams } from "react-router-dom";

import { useMemo, useState, useEffect } from "react";

import {
  useCheckReceiverIsInternalQuery,
  useGetMinimumWithdrawalAmountQuery,
  useWithdrawCryptoMutation,
} from "services/walletApi";
// import useCopy from "hooks/useCopy";
import useWallet from "hooks/useWalletBalance";

import toUpper from "lodash/toUpper";
import toLower from "lodash/toLower";
import toCoinLocale from "util/toCoinLocale";
import toPrecision from "util/toPrecision";

import constants from "config/constant";
import getError from "util/getError";
import useCoinInfo from "hooks/useCoinInfo";

const WalletDetailsWithdraw = (props) => {
  const currentPage = "Wallet";

  console.log(props);

  const { coin } = useParams();
  // const history = useHistory();
  const toast = useToast();
  const { getWalletInfo } = useCoinInfo();
  // const { onCopy } = useCopy("bc1ervghj324354ghj34354hvbj34b24gfhj");

  const [
    withdraw,
    { data: withdrawData, isLoading: isWithdrawing, isError, error, isSuccess },
  ] = useWithdrawCryptoMutation();

  const { data: minimumWithdrawData, isLoading: isLoadingMinimum } =
    useGetMinimumWithdrawalAmountQuery(coin);

  console.log("MINIMUM WITHDRAWAL AMOUNT", minimumWithdrawData);

  const { getBalance, getCoin } = useWallet();

  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isSuccessOpen,
    onClose: onSuccessClose,
    onOpen: onSuccessOpen,
  } = useDisclosure();

  const [state, setState] = useState();
  const handleState = (newState) => setState(() => ({ ...state, ...newState }));

  const skipAddressCheck = useMemo(() => {
    if (!state?.address) return true;
    if (coin && coin === "xlm" && !state?.memo && state?.address) return true;
    if (coin && coin === "xrp" && !state?.tagNumber && state?.address)
      return true;
    return false;
  }, [coin, state]);

  const query = useMemo(() => {
    if (coin === "xlm" && state?.memo) return `?memo=${state?.memo}`;
    if (coin === "xrp" && state?.tagNumber)
      return `?tagNumber=${state?.tagNumber}`;

    return "";
  }, [coin, state]);

  const { data: checkAddressData, isFetching } =
    useCheckReceiverIsInternalQuery(
      { address: state?.address, query, coin },
      { skip: skipAddressCheck }
    );

  console.log("Check address data", checkAddressData);

  useEffect(() => {
    if (isSuccess && withdrawData) {
      // toast({
      //   position: "bottom-right",
      //   title: "Success",
      //   description: "Withdraw successful",
      //   status: "success",
      //   duration: 4000,
      //   isClosable: true,
      // });
      onSuccessOpen();

      setState(null);

      // history.replace("/dashboard/cards");
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [isSuccess, error, withdrawData, isError, toast, onSuccessOpen]);

  const balance = useMemo(() => getBalance(coin) ?? 0, [getBalance, coin]);

  const fee = useMemo(() => {
    if (["usdc", "usdt"].includes(coin) && state?.network !== "tron") return 35;
    return constants.coins[coin]?.wallet?.withdraw?.fee;
  }, [coin, state?.network]);

  const minimumWithdraw = useMemo(() => {
    if (coin === "usdt" && state?.network !== "tron") return 50;
    // return constants.coins[coin]?.wallet?.withdraw?.minimum;
    return minimumWithdrawData?.min;
  }, [coin, state?.network, minimumWithdrawData]);

  console.log("Withdraw info", minimumWithdrawData);

  const qrCode = useMemo(() => getCoin(coin)?.qrCode, [getCoin, coin]);
  const coinImage = useMemo(() => {
    if (!!state?.network && state?.network === "tron")
      return getWalletInfo("usdt")?.image;
    if (!!state?.network && state?.network === "ethereum")
      return getWalletInfo("usdt")?.image;
    if (!!state?.network && state?.network === "polygon")
      return getWalletInfo("matic")?.image;
    return qrCode;
  }, [getWalletInfo, state?.network, qrCode]);

  const isFiat = useMemo(() => constants.fiats.includes(toLower(coin)), [coin]);

  const isLessThanMinimum = useMemo(
    () => state?.amount && Number(state?.amount) < +minimumWithdraw,
    [state, minimumWithdraw]
  );

  const isInsufficientBalance = useMemo(
    () => state?.amount && +state?.amount > balance,
    [state, balance]
  );

  const noNetwork = useMemo(
    () => ["usdc", "usdt"].includes(coin) && !state?.network,
    [coin, state?.network]
  );

  const isDisabled = useMemo(
    () =>
      !(state?.amount && state?.address) ||
      isLessThanMinimum ||
      isInsufficientBalance ||
      isWithdrawing ||
      noNetwork,
    [state, isLessThanMinimum, isInsufficientBalance, isWithdrawing, noNetwork]
  );

  console.log("STATE", state, isLessThanMinimum);

  const handleSubmit = (e) => {
    e.preventDefault();
    onOpen();
  };

  const handleWithdraw = () => {
    onClose();

    const reqData = {
      coin,
      reason: "A request to withdraw...",
      amount: state?.amount,
      destinationAddress: String(state.address).trim(),
      destinationCoin: coin,
      tagNumber: state?.tagNumber,
      memo: state?.memo,
      ...state,
      pin: state?.pin,
    };

    console.log("REQ DATA", reqData);

    withdraw(reqData);
  };

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["0", "0", "0"]}>
              <Heading fontSize="3xl">Wallet</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink
                    to={`/dashboard/wallet?tab=${isFiat ? "fiat" : "crypto"}`}
                  >
                    Wallet
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/wallet/${coin}`}>
                    {toUpper(coin)}
                  </BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Withdraw
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              w={["100%", "calc(100% - 25vw)"]}
              //   w="100%"
              mt="32px"
              borderRadius="16px"
              p="24px"
            >
              <HStack justifyContent="center">
                <Alert
                  status="info"
                  alignItems="flex-start"
                  borderRadius="8px"
                  w="fit-content"
                  bg="#e4f3fc"
                  mb="30px"
                >
                  <AlertIcon />
                  <Stack fontSize="sm">
                    <Text fontWeight="bold">
                      Estimated time to complete:{" "}
                      <Box color="blue.500" as="span">
                        2 minutes
                      </Box>
                    </Text>
                    <Text mt="0px !important">
                      Withdrawal to other Bitmama wallets is free
                    </Text>

                    {coin !== "matic" && (
                      <Badge
                        w="fit-content"
                        variant="subtle"
                        colorScheme="red"
                        textTransform="unset"
                      >
                        FEE:{" "}
                        {coin === "usdt"
                          ? "1 ~ 35 USDT"
                          : toPrecision(fee, coin)}
                      </Badge>
                    )}
                  </Stack>
                </Alert>
              </HStack>

              <VStack
                as="form"
                py="28px"
                w="100%"
                maxW={["100%", "70%"]}
                m="0 auto"
                onSubmit={handleSubmit}
              >
                <FormControl>
                  <Input
                    label={`${toCoinLocale(coin)} Address`}
                    isLoading={isFetching}
                    placeholder={`${toCoinLocale(coin)} Address`}
                    value={state?.address ?? ""}
                    onChange={(e) => handleState({ address: e.target.value })}
                    endAdornment={<Image boxSize="20px" src={coinImage} />}
                  />
                </FormControl>

                {["usdc", "usdt"].includes(coin) && (
                  <FormControl mt="16px !important">
                    <Select
                      label="Network"
                      placeholder="Select network"
                      value={state?.network ?? ""}
                      onChange={(e) => handleState({ network: e.target.value })}
                    >
                      {coin === "usdt" && (
                        <option value="tron">Tron (TRC20)</option>
                      )}
                      <option value="ethereum">Ethereum (ERC20)</option>
                      <option value="polygon">Polygon (MATIC)</option>
                    </Select>
                  </FormControl>
                )}

                {!noNetwork && (
                  <FormControl mt="16px !important">
                    <Input
                      isInvalid={isLessThanMinimum || isInsufficientBalance}
                      label={`${toCoinLocale(coin)} Amount`}
                      placeholder="0.00"
                      value={state?.amount ?? ""}
                      onChange={(e) => handleState({ amount: e.target.value })}
                    />

                    {isLessThanMinimum && (
                      <FormHelperText fontSize="xs" color="red.400">
                        Amount is less than minimum withdrawal amount
                      </FormHelperText>
                    )}
                    {isInsufficientBalance && (
                      <FormHelperText fontSize="xs" color="red.400">
                        Insufficient balance
                      </FormHelperText>
                    )}
                  </FormControl>
                )}

                {coin === "xrp" && (
                  <FormControl mt="16px !important">
                    <Input
                      label="Tag"
                      placeholder="Tag number"
                      value={state?.tagNumber ?? ""}
                      onChange={(e) =>
                        handleState({ tagNumber: e.target.value })
                      }
                    />
                  </FormControl>
                )}

                {coin === "xlm" && (
                  <FormControl mt="16px !important">
                    <Input
                      label="Memo"
                      placeholder="Memo"
                      value={state?.memo ?? ""}
                      onChange={(e) => handleState({ memo: e.target.value })}
                    />
                  </FormControl>
                )}

                <FormControl>
                  <FormHelperText as={HStack}>
                    <Text>Available balance:</Text>{" "}
                    <Text color="var(--primary)">
                      {toPrecision(balance, coin)}
                    </Text>
                  </FormHelperText>

                  {!noNetwork && !isLoadingMinimum && minimumWithdraw && (
                    <FormHelperText as={HStack}>
                      <Text>Minimum {toCoinLocale(coin)} Withdrawal:</Text>
                      <Text color="var(--primary)">
                        {toPrecision(minimumWithdraw, coin)}
                      </Text>
                    </FormHelperText>
                  )}

                  {coin === "usdt" && !noNetwork && (
                    <FormHelperText as={HStack}>
                      <Text>Network Fee:</Text>
                      <Text color="var(--primary)">
                        {toPrecision(fee, coin)}
                      </Text>
                    </FormHelperText>
                  )}
                </FormControl>

                <Button
                  disabled={isDisabled}
                  isLoading={isWithdrawing}
                  w="100%"
                  minH="64px"
                  mt="40px !important"
                  // onClick={onOpen}
                  type="submit"
                >
                  Continue
                </Button>
              </VStack>
            </Box>
          </Container>
        </Box>
      </Box>

      <Success
        onClose={onSuccessClose}
        isOpen={isSuccessOpen}
        title="Success"
        message="Withdraw successful"
      />

      <WithdrawPreview
        isOpen={isOpen}
        onClose={onClose}
        //   onConfirm={handleFreezeCard}
        state={{
          coin,
          address: getCoin(coin)?.address,
          amount: "0.00034",
          fees: fee,
          username: checkAddressData?.username,
          isInternalWallet: checkAddressData?.isInternalWallet,
          ...state,
          // status: "pending",
          // destination: "Internal",
          // otherFees: "NGN 10",
        }}
        setState={handleState}
        onConfirm={handleWithdraw}
        title="Withdraw Summary"
      />
    </Box>
  );
};

export default WalletDetailsWithdraw;
